<template>
  <div class="contact-page">
    <PageHeader
        :title="t('contactPage.header.title')"
        :subtitle="t('contactPage.header.subtitle')"
        :breadcrumbItems="[{ text: t('contactPage.navbar.home'), path: '/' }]"
        :currentText="t('contactPage.navbar.contact')"
    />

    <!-- 背景横幅 -->
<!--    <div-->
<!--        class="contact-banner"-->
<!--        :style="{ backgroundImage: `url(${require('@/assets/images/contact/咨询栏1.jpg')})` }"-->
<!--    >-->
<!--      <div class="overlay"></div>-->
<!--      <div class="banner-content">-->
<!--        <h2>{{ t('contactPage.banner.title') }}</h2>-->
<!--        <p>{{ t('contactPage.banner.desc') }}</p>-->
<!--      </div>-->
<!--    </div>-->

    <div class="page-container">
      <div class="contact-content">
        <!-- 联系信息 -->
        <div class="contact-info">
          <h2 class="section-title">{{ t('contactPage.contactInfo.title') }}</h2>
          <div class="info-list">
            <div class="info-item">
              <i class="el-icon-location"></i>
              <div class="info-text">
                <h3>{{ t('contactPage.contactInfo.addressTitle') }}</h3>
                <p>{{ t('contactPage.contactInfo.address') }}</p>
              </div>
            </div>
            <div class="info-item">
              <i class="el-icon-phone"></i>
              <div class="info-text">
                <h3>{{ t('contactPage.contactInfo.phoneTitle') }}</h3>
                <p>0631-5380169</p>
              </div>
            </div>
            <div class="info-item">
              <i class="el-icon-message"></i>
              <div class="info-text">
                <h3>{{ t('contactPage.contactInfo.faxTitle') }}</h3>
                <p>0631-5380166</p>
              </div>
            </div>
            <div class="info-item">
              <i class="el-icon-time"></i>
              <div class="info-text">
                <h3>{{ t('contactPage.contactInfo.emailTitle') }}</h3>
                <p>{{"18663127999@163.com"}}</p>
              </div>
            </div>
          </div>

          <!-- 社交媒体 -->
<!--          <div class="social-links">-->
<!--            <h3>{{ t('contactPage.social.title') }}</h3>-->
<!--            <div class="social-icons">-->
<!--              <a href="#" class="social-icon"><i class="el-icon-s-custom"></i></a>-->
<!--              <a href="#" class="social-icon"><i class="el-icon-s-promotion"></i></a>-->
<!--              <a href="#" class="social-icon"><i class="el-icon-s-check"></i></a>-->
<!--              <a href="#" class="social-icon"><i class="el-icon-s-goods"></i></a>-->
<!--            </div>-->
<!--          </div>-->

          <!-- 公司照片 -->
          <div class="company-photos">
            <h3>{{ t('contactPage.photos.title') }}</h3>
            <div class="photo-grid">
              <div class="photo-item">
                <img :src="require('@/assets/images/about/img10.jpg')" :alt="t('contactPage.photos.alt')" />
              </div>
              <div class="photo-item">
                <img :src="require('@/assets/images/about/img11.jpg')" :alt="t('contactPage.photos.alt')" />
              </div>
              <div class="photo-item">
                <img :src="require('@/assets/images/about/img12.jpg')" :alt="t('contactPage.photos.alt')" />
              </div>
              <div class="photo-item">
                <img :src="require('@/assets/images/about/img13.jpg')" :alt="t('contactPage.photos.alt')" />
              </div>
            </div>
          </div>
        </div>

        <!-- 联系表单 -->
        <div class="contact-form-container">
          <h2 class="section-title">{{ t('contactPage.form.title') }}</h2>
          <p class="form-desc">{{ t('contactPage.form.desc') }}</p>
          <ContactForm />
        </div>
      </div>

      <!-- 常见问题 -->
      <div class="faq-section">
        <h2 class="section-title text-center">{{ t('contactPage.faq.title') }}</h2>
        <p class="section-desc text-center">{{ t('contactPage.faq.desc') }}</p>

        <el-collapse>
          <el-collapse-item :title="t('contactPage.faq.q1')" name="1">
            <div>{{ t('contactPage.faq.a1') }}</div>
          </el-collapse-item>
          <el-collapse-item :title="t('contactPage.faq.q2')" name="2">
            <div>{{ t('contactPage.faq.a2') }}</div>
          </el-collapse-item>
          <el-collapse-item :title="t('contactPage.faq.q3')" name="3">
            <div>{{ t('contactPage.faq.a3') }}</div>
          </el-collapse-item>
          <el-collapse-item :title="t('contactPage.faq.q4')" name="4">
            <div>{{ t('contactPage.faq.a4') }}</div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import PageHeader from '@/components/PageHeader.vue'
import ContactForm from '@/components/ContactForm.vue'

const { t } = useI18n()
</script>


<style lang="scss" scoped>
.contact-page {
  padding-top: 100px; /* 根据导航栏高度调整 */

  padding-bottom: 60px;

  .contact-banner {
    height: 300px;
    background-size: cover;
    background-position: center;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 60px;

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
    }

    .banner-content {
      position: relative;
      z-index: 2;
      text-align: center;
      color: #fff;

      h2 {
        font-size: 36px;
        font-weight: 700;
        margin-bottom: 15px;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
      }

      p {
        font-size: 18px;
        max-width: 600px;
        margin: 0 auto;
        opacity: 0.9;
      }
    }
  }

  .contact-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 50px;
    margin-bottom: 60px;

    @media (max-width: 992px) {
      grid-template-columns: 1fr;
    }

    .contact-info {
      .section-title {
        margin-bottom: 30px;
      }

      .info-list {
        margin-bottom: 40px;

        .info-item {
          display: flex;
          align-items: flex-start;
          margin-bottom: 25px;

          i {
            font-size: 24px;
            color: #409EFF;
            margin-right: 15px;
            margin-top: 5px;
          }

          .info-text {
            h3 {
              font-size: 16px;
              font-weight: 600;
              color: #333;
              margin-bottom: 5px;
            }

            p {
              font-size: 15px;
              color: #666;
              margin: 0;
            }
          }
        }
      }

      .social-links {
        margin-bottom: 40px;

        h3 {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 20px;
          color: #333;
        }

        .social-icons {
          display: flex;
          gap: 15px;

          .social-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 44px;
            height: 44px;
            border-radius: 50%;
            background-color: #f5f7fa;
            color: #409EFF;
            text-decoration: none;
            transition: all 0.3s ease;

            i {
              font-size: 20px;
            }

            &:hover {
              background-color: #409EFF;
              color: #fff;
              transform: translateY(-3px);
            }
          }
        }
      }

      .company-photos {
        h3 {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 20px;
          color: #333;
        }

        .photo-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 15px;

          .photo-item {
            border-radius: 8px;
            overflow: hidden;
            height: 140px;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              transition: transform 0.3s ease;

              &:hover {
                transform: scale(1.05);
              }
            }
          }
        }
      }
    }

    .contact-form-container {
      .section-title {
        margin-bottom: 15px;
      }

      .form-desc {
        font-size: 15px;
        color: #666;
        margin-bottom: 30px;
      }
    }
  }

  .faq-section {
    .section-title {
      margin-bottom: 15px;

      &.text-center {
        text-align: center;
      }
    }

    .section-desc {
      font-size: 15px;
      color: #666;
      margin-bottom: 30px;
      max-width: 700px;
      margin-left: auto;
      margin-right: auto;

      &.text-center {
        text-align: center;
      }
    }
  }
}

.section-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 10px;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 40px;
    height: 3px;
    background-color: #409EFF;
  }

  &.text-center {
    &::after {
      left: 50%;
      transform: translateX(-50%);
    }
  }
}

.page-container {
  max-width: 1200px;
  padding: 0 15px;
  margin: 0 auto;
}
</style>
